<ng-container *ngIf="mapChartMetrics$ | async">
  <div class="spouse-map-wrap flex flex-col">
    <div id="spouseMapChart" class="flex justify-center"></div>
  </div>
</ng-container>
